import { StrategyOriginTypes } from "@/app/strategies/utils/enums";

export const agentsTableColumns = [
  // { title: "N°", dataIndex: "number", width: 50 },
  { title: "Usuario", dataIndex: "name", ellipsis: true },
  { title: "Estado", dataIndex: "event", width: 150, slots: { customRender: "status" } },
  {
    dataIndex: "webphone_status",
    slots: { title: "webphoneTitle", customRender: "webphoneBody" },
    width: 60,
    align: "center",
  },
];

export const agentsTableColumnsProgressive = [
  // { title: "N°", dataIndex: "number", width: 50 },
  { title: "Nombre de usuario", dataIndex: "name", ellipsis: true },
  { 
    dataIndex: "user_progress", 
    width: 150, 
    slots: { title: "userProgressTitle", customRender: "userProgressBody" } 
  },
];


export const callsInQueueColumns = [
  { title: "Teléfono", dataIndex: "phone", slots: { customRender: "phone" } },
  { title: "Tiempo en cola", dataIndex: "updated_at", slots: { customRender: "queueTime" } },
];

export const callsStateColumns = [
  { title: "Teléfono", dataIndex: "phone" },
  { title: "Estado", dataIndex: "status" },
];

export const strategyTableColumns = [
  { title: "ID", width: 60, dataIndex: "id", key: "age" },
  {
    title: "Nombre de la estrategia",
    dataIndex: "name",
    key: "name",
    width: 250,
    ellipsis: true,
  },
  {
    title: "Tipo de creación",
    dataIndex: "type_origin",
    width: 150,
    customRender: ({ text }) => (text ? StrategyOriginTypes[text] : "-"),
  },
  {
    title: "Tipo de estrategia",
    dataIndex: "type_strategy_name",
    key: "type_strategy_name",
    width: 180,
  },
  {
    title: "Tipo de asignación",
    dataIndex: "type_assignment",
    key: "type_assignment",
    width: 150,
  },
  {
    // slots: { title: "titleEntity", customRender: "entity" },
    title: "Empresa",
    dataIndex: "entity",
    key: "entity",
    width: 200,
    ellipsis: true,
  },
  { title: "Campaña", dataIndex: "portfolio", key: "portfolio", width: 200, ellipsis: true },
  {
    title: "Creado por",
    dataIndex: "created_by",
    key: "created_by",
    width: 150,
  },
  {
    title: "F. de creación",
    dataIndex: "date_created",
    key: "date_created",
    width: 140,
    // slots: { customRender: "date_created" },
  },
  {
    title: "F. de lanzamiento",
    dataIndex: "date_launched",
    key: "date_launched",
    width: 200,
    // slots: { customRender: "date_launched" },
  },
  {
    title: "Ejecutado/Pausado por",
    dataIndex: "turned_on_by",
    key: "turned_on_by",
    width: 200,
    // slots: { customRender: "date_launched" },
  },
  {
    title: "Progreso / Total",
    width: 200,
    key: "stats",
    dataIndex: "stats",
    // slots: { customRender: "stats" },
  },
  {
    title: "Estados de la estrategia",
    width: 200,
    key: "strategy_status",
    dataIndex: "strategy_status",
  },
  { title: "N. Contactos", dataIndex: "number_clients", width: 120 },
  {
    title: "Acciones",
    key: "actions",
    fixed: "right",
    width: 110,
    // slots: { customRender: "actions" },
  },
];
